// see docs/customisation-app.md § PDP load sequence — this fetches in the constructor
if (!customElements.get('lazy-section')) {
  customElements.define(
    'lazy-section',
    class LazySection extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.fetchKey = this.dataset.fetchKey;
        this.replaceSelector = this.dataset.replaceSelector;
        this.path = this.dataset.path;

        //want to be able to render sections from other pages, where the section id is not known
        // be able to pass html id that is used to fetch

        this.selectorId = this.dataset.selectorId;
        this.params = this.dataset.params;

        if (
          !(this.sectionId || this.selectorId) ||
          !this.fetchKey ||
          !this.replaceSelector ||
          !this.path
        )
          return;

        this.loadLazySection();
      }

      async loadLazySection() {
        var url = this.createFetchUrl();

        var section_markup = await this.fetchSection(url);

        if (!section_markup) return;

        this.renderAndReplace(section_markup);
      }

      createFetchUrl() {
        const fetch_url = this.sectionId
          ? `${this.path}/${this.fetchKey}?section_id=${this.sectionId}`
          : `${this.path}/${this.fetchKey}?selector=${this.sectionId}&${this.params}`;

        return fetch_url;
      }

      async fetchSection(fetch_url) {
        if (!fetch_url) return;

        return fetch(fetch_url)
          .then((response) => response.text())
          .then((data) => {
            return data;
          })
          .catch((e) => {
            debugger;
          });
      }

      renderAndReplace(markupText) {
        var html = new DOMParser().parseFromString(markupText, 'text/html');

        var new_el = html.querySelector(this.replaceSelector);
        var old_el = this.querySelector(this.replaceSelector);

        if (!new_el || !old_el) {
          console.error('Error loading LazySection html');
          return;
        }

        old_el.replaceWith(new_el);

        this.dispatchCappInit();
      }

      dispatchCappInit() {
        this.params = this.dataset.params;

        var detail = this.params
          ? {
              detail: { params: `?${this.params}` },
            }
          : {};

        document.dispatchEvent(
          new CustomEvent('section-loaded-replaced', detail),
        );
      }
    },
  );
}
